import React, { useState, useEffect } from 'react';
import moment from 'moment/moment';

//Components
import MainCard from '../../components/MainCard/MainCard';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';
import FichaCorreioInterno from './FichaCorreioInterno';
import NovoCorreioInterno from './NovoCorreioInterno';
import Loading from '../../components/Loading/Loading';

//Api
import correioInterno_api from '../../api/correioInterno_api';

//Helpers
import { showMessage } from '../../helpers/message';

//Constants
import { actionsTable } from '../../constants/MaterialTable';

export default function CorreioInterno() {
    //Ações da tabela
    const actions = [actionsTable.visualizar((item) => setFicha(item.id))];

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle da tela de novo correio interno
    const [novo, setNovo] = useState(false);

    //Estado de controle da tela de ficha do correio interno
    const [ficha, setFicha] = useState(false);

    //Estado que guarda a lista de correios internos cadastrados
    const [mensagens, setMensagens] = useState([]);

    //Cabeçalhos das tabelas
    const headers = [
        { value: "Título", objectValue: "titulo" },
        { value: "Data da mensagem", objectValue: "dataEnvio" },
        { value: "Quantidade Usuários", objectValue: "quantidadeDestinos" },
        { value: "Quantidade Lidos", objectValue: "quantidadeLidos" },
        { value: "Destinatário", objectValue: "destinatario" },
    ]

    //Carrega a lista de correios internos
    const loadCorreiosInternos = () => {
        setLoading(true);
        correioInterno_api.GetList().then(response => {
            response.data = response.data.map(value => {
                value.dataEnvio = moment(value.dataEnvio).format("DD/MM/YYYY HH:mm:ss");
                return value;
            });
            setMensagens(response.data);
        }).catch(e => { showMessage("Aviso", e.message, "error", null) })
            .finally(f => setLoading(false));
    }

    //Carrega a lista de correios internos assim que a tela é carregada
    useEffect(() => {
        loadCorreiosInternos();
    }, []);

    //Controle de exibição da tela de novo correio interno
    if (novo) {
        return <NovoCorreioInterno btnVoltar={() => {
            loadCorreiosInternos();
            setNovo(false);
        }} />
    }

    //Controle de exibição da tela de ficha
    if (ficha) {
        return <FichaCorreioInterno btnVoltar={() => {
            loadCorreiosInternos();
            setFicha(false);
        }} id={ficha} />
    }

    return (
        <MainCard noCard btnCadastro="Adicionar" onClickBtnCadastro={() => setNovo(true)}>
            {loading && <Loading />}
            <div className="mt-4">
                <TabelaListagem actions={actions} title='Lista de correios internos' headers={headers} items={mensagens} options={{ print: false, search: true, pagination: true }} />
            </div>
        </MainCard>
    )
}